"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _usePostSubscription = require("./usePostSubscription");
Object.keys(_usePostSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePostSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _usePostSubscription[key];
    }
  });
});
